import { Button, Flex, Header, Image } from "@mantine/core";
import logo from "asset/logo.png";
import { useNavigate } from "react-router-dom";

function SRD_Header() {
  const navigate = useNavigate();

  return (
    <Header>
      <Flex h={60} mx={50} align="center" justify="space-between">
        <Image maw={200} src={logo} alt="Logo" />
        <Button onClick={() => navigate("/logout")}>
          로그아웃
        </Button>
      </Flex>
    </Header>
  );
}

export default SRD_Header;
